import { render, staticRenderFns } from "./NewDesignModal.vue?vue&type=template&id=094aeeb2&scoped=true"
import script from "./NewDesignModal.vue?vue&type=script&lang=ts"
export * from "./NewDesignModal.vue?vue&type=script&lang=ts"
import style0 from "./NewDesignModal.vue?vue&type=style&index=0&id=094aeeb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094aeeb2",
  null
  
)

export default component.exports